export default {
  // meta
  Pending: "En attente",
  Approved: "Approuvé",
  Completed: "Terminé",
  Cancelled: "Annulé",
  ID: "ID",
  Debit: "Débit",
  Credit: "Crédit",
  Account: "Compte",
  Status: "Statut",
  Date: "Date",
  Actions: "Actions",

  // form
  "Create Transaction": "Créer une transaction",
  "Edit Transaction": "Modifier la transaction",
  Description: "Description",
  "Payment Method": "Méthode de paiement",

  // table
  "All statuses": "Tous les statuts",

  // select
  Transaction: "Transaction",
  "Search by ID, description or account":
    "Rechercher par ID, description ou compte",
  "Edit Selection": "Modifier la sélection",
  "No transactions found": "Aucune transaction trouvée",

  // modals
  "Transaction Details": "Détails de la transaction",
  User: "Utilisateur",
  Segment: "Segment",
  "Payable Type": "Type payable",
  Created: "Créé",
  Updated: "Mis à jour",

  // delete
  "Do you really want to delete this transaction?":
    "Voulez-vous vraiment supprimer cette transaction ?",
  "Warning: This action is irreversible.":
    "Attention : cette action est irréversible.",
  "Confirm Deletion": "Confirmer la suppression",
  Cancel: "Annuler",

  // block
  "Finance Transactions": "Transactions financières",
  "Add Transaction": "Ajouter une transaction",
  "Transactions history": "Historique transactions",

  "Treasury account": "Compte de trésorerie",
  Transfers: "Transferts",
  transfers: "transferts",
  "Income categories": "Catégories de revenus",
  Incomes: "Revenus",
  incomes: "revenus",
  "Expense categories": "Catégories de dépenses",
  Expenses: "Dépenses",
  expenses: "dépenses",
  "Customers debts": "Dettes clients",
  "Suppliers credits": "Crédits fournisseurs",
  "Suppliers debts": "Dettes fournisseurs",
  "Total Incomes": "Total des revenus",
  "Total Expenses": "Total des dépenses",
  "Own by customers": "Dû par les clients",
  "Own by suppliers": "Dû par les fournisseurs",
  "Own to suppliers": "Dû aux fournisseurs",
  "Incomes and expenses": "Revenus et dépenses",
  Debts: "Dettes",
  debts: "dettes",
  "Top Incomes categories": "Top catégories de revenus",
  "Top Expenses categories": "Top catégories de dépenses",
  "Top Customers Debitors": "Top clients débiteurs",
  "Top Suppliers Debitors": "Top fournisseurs débiteurs",
  "Top Suppliers Creditors": "Top fournisseurs créanciers",
  "Total Balance": "Solde total",
  "Gross Debt": "Dette brute",
};
